import { TeamCardContent } from './TeamCardContent';
import {
  Button,
  PopoverItem,
} from '@trufla-technology/trumarket-react-design-system';
import { useHistory, useParams } from 'react-router';
import { TeamsType } from '../../types/User';
import { NewTeam } from '../../forms/NewTeam';
import { join } from 'lodash';
import './style.scss';
import { TeamsLoading } from './TeamsLoading';
import { useAuthContext } from '@trufla-technology/trufla-trudomain/dist/lib';

type Props = {
  teams: TeamsType;
  refetchTeams?: () => void;
  loading?: boolean;
  lastUpdated?: boolean;
};

export const Teams = ({ lastUpdated, teams, refetchTeams, loading }: Props) => {
  const { isPermitted } = useAuthContext();
  const { key: userKey } = useParams<any>();
  const history = useHistory();
  const teamsKeysString = join(
    teams?.map((team) => [team.key]),
    ',',
  );
  const openAddTeamPopover = () => {
    history.replace(`?new=team&userKey=${userKey}`);
  };

  if (loading) return <TeamsLoading />;
  return (
    <div className="teams-container">
      <div className="teams-container-header">
        <h3>Teams ({teams?.length})</h3>
        {isPermitted('assignUsersToTeams') && (
          <Button onClick={openAddTeamPopover} type="primary">
            Assign to Team
          </Button>
        )}
      </div>

      {!teams?.length ? (
        <div className="no-teams">No Teams</div>
      ) : (
        <div className="team-list">
          {teams?.map((team) => (
            <TeamCardContent
              key={team.key}
              team={team}
              lastUpdated={lastUpdated}
              refetchTeams={refetchTeams}
            />
          ))}
        </div>
      )}

      {isPermitted('assignUsersToTeams') && (
        <PopoverItem
          title="Assign To Team"
          match="new=team"
          showBackArrow
          component={() => (
            <NewTeam
              refetchTeams={refetchTeams}
              teamsKeysString={teamsKeysString}
            />
          )}
          onClose={() => history.push(history.location.pathname)}
        />
      )}
    </div>
  );
};
